import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Container, InputBase, makeStyles } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import FilterListIcon from '@material-ui/icons/FilterList';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import AddIcon from '@material-ui/icons/Add';
import CardTema from './CardTema';
import FilterRedacao from '../../components/FilterRedacao';
import axios from 'axios';
import { API_HOST } from '../../consts';
import { DivFather, ToolBarContainer } from './styles/ListRedacoesStyles';
import { get } from 'lodash';
import ReactPaginate from 'react-paginate';
import NavBreadCrumb from '../../containers/NavBreadCrumb';
import Loading from '../../components/Loading';

const useStyles = makeStyles((theme) => ({
  search: {
    position: 'relative',
    borderRadius: '40px',
    marginRight: theme.spacing(2),
    marginLeft: 0,
    width: '100%',
    backgroundColor: '#E5E7EB'
  },
  searchIcon: {
    padding: theme.spacing(0, 2),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  inputRoot: {
    color: 'inherit',
    width: '100%'
  },
  inputInput: {
    padding: theme.spacing(1, 1, 1, 0),
    paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
    transition: theme.transitions.create('width'),
    width: '100%'
  }
}));

export default function ListRedacoes(props) {
  const [temas, setTemas] = useState([]);
  const [temasCountPagination, setTemasCountPagination] = useState();
  const [searchBar, setSearchBar] = useState('');
  const [updateTema, setUpdateTema] = useState(true);
  const [open, setOpen] = useState(false);
  const [filterRedacao, setFilterRedacao] = useState({});
  const [pageSize, setPageSize] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [isLoading, setIsLoading] = useState(false);

  const classes = useStyles();

  const searchWithParams = async () => {
    setIsLoading(true);
    try {
      const params = {
        genero: filterRedacao.genero,
        periodo: filterRedacao.periodo,
        status: filterRedacao.status,
        tipo: filterRedacao.tipo,
        pedido_status: filterRedacao.pedido_status,
        ordering: '-criado_em',
        search: searchBar,
        page: currentPage
      };

      if (searchBar) {
        delete params.page;
        setPageSize('');
        setTemasCountPagination('');
      }

      const response = await axios.get(`${API_HOST}/redacao_temas/temas`, {
        params
      });

      setPageSize(response.data.total_pages);
      setIsLoading(false);
      setTemasCountPagination(response.data);
      setTemas(response.data.results);
    } catch (err) {
      console.error(err);
      setIsLoading(false);
    }
  };

  const handlePageClick = (data) => {
    const selectedPage = data.selected;
    setCurrentPage(selectedPage + 1);
  };

  useEffect(() => {
    searchWithParams();
  }, [updateTema, currentPage, searchBar, filterRedacao]);

  const handleSeachBar = (e) => {
    setSearchBar(e.target.value);
  };

  const handleChangeFilter = (key, value) => {
    setFilterRedacao((prev) => ({ ...prev, [key]: value }));
  };

  const fetchWithSearch = async (filterFields) => {
    const params = {
      genero: filterFields.genero,
      periodo: filterFields.periodo,
      status: filterFields.status,
      tipo: filterFields.tipo,
      pedido_status: filterFields.pedido_status
    };

    const response = await axios.get(
      `${API_HOST}/redacao_temas/temas?ordering=-criado_em`,
      { params }
    );

    setTemas(response.data.results);
  };

  const handleDateFilter = async (order) => {
    const response = await axios.get(
      `${API_HOST}/redacao_temas/temas?ordering=${order}criado_em`
    );

    setTemas(response.data.results);
    setPageSize(response.data.total_pages);
    setTemasCountPagination(response.data);
  };

  const renderToolbar = () => {
    return (
      <ToolBarContainer>
        <div className="d-flex">
          <div
            className="search mr-2"
            style={{
              display: 'flex',
              width: '640px',
              fontFamily: 'Public Sans'
            }}
          >
            <div className={classes.search}>
              <div className={classes.searchIcon}>
                <SearchIcon
                  style={{
                    color: '#0047B6',
                    background: 'white',
                    borderRadius: '50%',
                    width: '28px',
                    height: '28px',
                    padding: '5px',
                    marginLeft: '-9px',
                    fontFamily: 'Public Sans'
                  }}
                />
              </div>
              <InputBase
                placeholder="Pesquisar"
                classes={{
                  root: classes.inputRoot,
                  input: classes.inputInput
                }}
                onChange={(e) => handleSeachBar(e)}
                style={{ width: '400px', height: '40px' }}
                inputProps={{ 'aria-label': 'search' }}
              />
            </div>
          </div>
          <div style={{ marginLeft: '0.5rem' }}>
            <button
              style={{
                marginRight: '1em',
                background: '#CBE4FF',
                border: 'none',
                color: '#0047B6',
                borderRadius: '24px',
                padding: '8px 8px 8px 8px',
                fontSize: '16px',
                fontWeight: '700',
                fontFamily: 'Public Sans'
              }}
              onClick={() => setOpen(true)}
            >
              <FilterListIcon style={{ marginRight: '.5em' }} />
              Filtrar
            </button>
          </div>

          <div className="ml-2">
            <button
              style={{
                marginRight: '1em',
                background: '#CBE4FF',
                border: 'none',
                color: '#0047B6',
                borderRadius: '24px',
                padding: '8px 8px 8px 12px',
                fontSize: '16px',
                fontWeight: '700',
                fontFamily: 'Public Sans'
              }}
            >
              <select
                onChange={(e) => handleDateFilter(e.target.value)}
                style={{
                  background: '#CBE4FF',
                  border: 'none',
                  color: '#0047B6',
                  fontSize: '16px',
                  fontWeight: '700',
                  marginRight: '-32px',
                  fontFamily: 'Public Sans'
                }}
                tabIndex={-1}
              >
                <option value="" label="">
                  Ordenar
                </option>
                <option value="+" label="Mais Antigos">
                  Mais Antigos
                </option>
                <option value="-" label="Recentes">
                  {' '}
                  Recentes
                </option>
              </select>
              <ArrowDropDownIcon style={{ marginLeft: '.2em' }} />
            </button>
          </div>
        </div>
        <button
          style={{
            display: 'flex',
            alignItems: 'center',
            background: '#0047B6',
            border: 'none',
            color: 'white',
            borderRadius: '24px',
            padding: '8px 10px',
            fontSize: '16px',
            fontWeight: '700',
            textAlign: 'center',
            fontFamily: 'Public Sans'
          }}
        >
          <Link
            to="/redacao/create"
            style={{
              color: 'white',
              fontFamily: 'Public Sans'
            }}
          >
            <AddIcon />
            Criar
          </Link>
        </button>
        <button
          style={{
            display: 'flex',
            alignItems: 'center',
            background: '#0047B6',
            border: 'none',
            color: 'white',
            borderRadius: '24px',
            padding: '8px 10px',
            fontSize: '16px',
            fontWeight: '700',
            textAlign: 'center',
            fontFamily: 'Public Sans',
            marginLeft: '15px'
          }}
        >
          <Link
            to="/redacao/create-ia"
            style={{
              color: 'white',
              fontFamily: 'Public Sans'
            }}
          >
            <AddIcon />
            Criar com IA
          </Link>
        </button>
      </ToolBarContainer>
    );
  };

  const filterTemas = () => {
    if (props.user.logged_group.includes('ADMINISTRADOR')) {
      // todo definir regra de negocio
      return !searchBar
        ? temas
        : temas.filter((tema) =>
            tema.nome.toLowerCase().includes(searchBar.toLowerCase())
          );
    }
    return !searchBar
      ? temas.filter((tema) => tema.status !== 3)
      : temas.filter(
          (tema) =>
            tema.status !== 3 &&
            tema.nome.toLowerCase().includes(searchBar.toLowerCase())
        );
  };

  return (
    <Container maxWidth="xl">
      <NavBreadCrumb currentPath={'Temas de Redações'} hasBackslash={false} />
      <DivFather>
        {renderToolbar()}
        {isLoading ? (
          <div className="p-5">
            <Loading />
          </div>
        ) : (
          filterTemas().map((tema) => (
            <CardTema
              redacaoTema={tema}
              setUpdateTema={setUpdateTema}
              updateTema={updateTema}
              history={props.history}
              user={props.user}
            />
          ))
        )}
        <div
          style={{
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-around'
          }}
        >
          <p style={{ marginBottom: 5, marginTop: 10 }}>
            Mostrando <b>{temas.length}</b> de{' '}
            <b>{get(temasCountPagination, 'count', '-')}</b> registros
          </p>
          <ReactPaginate
            pageCount={pageSize}
            pageRangeDisplayed={2}
            marginPagesDisplayed={1}
            onPageChange={handlePageClick}
            previousLabel="ANTERIOR"
            nextLabel="PRÓXIMA"
            containerClassName={'pagination'}
            activeClassName={'active'}
          />
        </div>
      </DivFather>
      <FilterRedacao
        open={open}
        fetchWithSearch={fetchWithSearch}
        handleClose={() => setOpen(false)}
        onChange={handleChangeFilter}
      ></FilterRedacao>
    </Container>
  );
}
